import React, { useRef, useEffect, useCallback } from 'react';
import { useSpring, animated } from 'react-spring';
import styled from 'styled-components';
import CloudImage from '../assets/images/cloud.png';
import Close from '../assets/images/close.svg';
import { Modal } from '@mui/material';
import { useTranslation } from 'react-i18next';

const Background = styled.div`
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.1);
    position: fixed;
    display: flex;
    justify-content: center;
    align-items: center;
    overflow-y: scroll;
    ::-webkit-scrollbar {
        display: none;
    }
`;

const ModalWrapper = styled.div`
    width: 80vw;
    height: 100%;
    max-width: 1200px;
    padding:50px 0;
    box-shadow: 0 5px 16px rgba(0, 0, 0, 0.2);
    background: #8bd1eb;
    border: 1px solid #707070;
    color: #000;
    display: grid;
    position: relative;
    z-index: 10;
    border-radius: 15px;
`;

const CloudImage1 = styled.img`
    position: absolute;
    height: 80px;
    top: -50px;
    right: 20%;
    @media screen and (max-width: 768px) {
        height: 50px;
        top: -30px;
    }
`;
const CloudImage2 = styled.img`
    position: absolute;
    height: 60px;
    right: -50px;
    bottom: 10%;
    @media screen and (max-width: 768px) {
        height: 40px;
        right: -30px;
    }
`;
const CloudImage3 = styled.img`
    position: absolute;
    height: 60px;
    left: -50px;
    top: 20%;
    @media screen and (max-width: 768px) {
        height: 40px;
        left: -30px;
    }
`;
const CloudImage4 = styled.img`
    position: absolute;
    height: 80px;
    bottom: -35px;
    left: 20%;
    @media screen and (max-width: 768px) {
        height: 50px;
        bottom: -20px;
    }
`;
const ModalContent = styled.div`
    display: flex;
    align-items: center;
    line-height: 1.8;
    color: #141414;
    h1 {
        color: #212121;
        font-size: 35px;
        font-weight: 900;
        font-family: 'Bungee', cursive;
        margin: 0;
        &.value {
            color: #ffffff;
            margin-left: 10px;
        }
        @media screen and (max-width: 1240px) {
            font-size: 26px;
        }
        @media screen and (max-width: 1024px) {
            font-size: 22px;
        }
        @media screen and (max-width: 577px) {
            font-size: 16px;
        }
    }
    @media screen and (max-width: 768px) {
        flex-direction: column;
    }
`;
const CloseModalButton = styled.p`
    cursor: pointer;
    position: absolute;
    display: flex;
    align-items: center;
    justify-content: center;
    top: 10px;
    right: 20px;
    width: 35px;
    height: 35px;
    &::after {
        content: '';
        width: 0;
        height: 0;
        position: absolute;
        border-radius: 50%;
        background-color: #212121;
        z-index: -1;
        transition: all 0.5s ease-in-out;
    }
    &:hover::after {
        width: 40px;
        height: 40px;
    }
    @media screen and (max-width: 577px) {
        top: -5px;
        right: 8z px;
    }
`;
const TopContent = styled.div`
    width: 50%;
    margin: 40px 0;
    display: flex;
    justify-content: center;
    align-items: center;
    @media screen and (max-width: 768px) {
        padding: 0;
        width: 100%;
        flex-direction: column !important;
        width: unset;
        margin: 30px 0;
    }
`;
const Card = styled.a`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    background: #fed743;
    border: 5px solid #212121;
    width: fit-content;
    margin-bottom: 30px;
    padding: 0px 30px;
    height: 60px;
    text-decoration: none;
    transition: all 0.2s ease-in-out;
    h2 {
        color: #212121;
        font-size: 28px;
        font-weight: 500;
        font-family: 'Bungee', cursive;
        margin: 0;
        text-align: center;
    }
    @media screen and (max-width: 1240px) {
        height: 50px;
        h2 {
            color: #212121;
            font-size: 35px;
            font-weight: 900;
            font-family: 'Bungee', cursive;
            margin: 0;
        }
    }
    @media screen and (max-width: 1240px) {
        h2 {
            font-size: 20px;
        }
    }
    @media screen and (max-width: 768px) {
        flex-direction: row;
        height: 45px;
        margin: 10px 0 10px 0;
        border: 5px solid #212121;
    }
    @media screen and (max-width: 577px) {
        border: 3px solid #212121;
        height: 30px;
        h2 {
            font-size: 13px;
            font-weight: 500;
        }
    }
`;
const BottomContent = styled.div`
    margin-top: 20px;
    width: 50%;
    display: flex;
    align-items: center;
    flex-direction: column;
    justify-content: space-around;
    margin: 50px 0;

    h1{
        margin-bottom:32px;
        margin-top:-30px;
    }
    @media screen and (max-width: 1024px) {
        h1{
        margin-bottom:10px;
        margin-top:0px;
    }
    }
    @media screen and (max-width: 768px) {
        justify-content: center;
        width: 100%;
        margin: 20px 0 40px 0;
    }
`;

const Button = styled.button`
    background-color: #fed743 !important;
    border: 5px solid #212121 !important;
    margin: 10px;
    padding:0 20px;
    color: #212121;
    font-size: 25px;
    font-weight: 900;
    font-family: 'Bungee', cursive;
    width: fit-content;
    cursor: pointer;
    height: 70px;
    line-height: 30px;

    @media screen and (max-width: 1240px) {
        height: 60px;
        font-size: 20px;
        padding:0 10px;
    }
    @media screen and (max-width: 1024px) {
        height: 60px;
        font-size: 15px;
    }
    @media screen and (max-width: 768px) {
        height: 50px;
        margin: 5px;
    }
    @media screen and (max-width: 577px) {
        border: 3px solid #212121 !important;
        height: 40px;
        font-size: 11px;
    }
`;

export const BugBountyModal = ({
    isFeedback,
    setIsFeedback,
}) => {
    const modalRef = useRef();
    const { t } = useTranslation();

    const animation = useSpring({
        config: {
            duration: 200,
        },
        opacity: isFeedback ? 1 : 0,
    });
    const keyPress = useCallback(
        (e) => {
            if (e.key === 'Escape' && isFeedback) {
                setIsFeedback(false);
            }
        },
        [setIsFeedback, isFeedback]
    );

    useEffect(() => {
        document.addEventListener('keydown', keyPress);
        return () => document.removeEventListener('keydown', keyPress);
    }, [keyPress]);

    return (
        <>
            {isFeedback ? (
                <Modal
                    open={isFeedback}
                    aria-labelledby='modal-modal-title'
                    aria-describedby='modal-modal-description'
                >
                    <Background ref={modalRef}>
                        <animated.div style={animation}>
                            <ModalWrapper showModal={isFeedback}>
                                <ModalContent>
                                    <CloudImage1 src={CloudImage} alt='cloud' />
                                    <CloudImage2 src={CloudImage} alt='cloud' />
                                    <CloudImage3 src={CloudImage} alt='cloud' />
                                    <CloudImage4 src={CloudImage} alt='cloud' />
                                    <TopContent>
                                    <Card
                                      href='https://docs.google.com/forms/d/e/1FAIpQLSd5S0XqU_3Ziubz_dwloLANyKy2uhsxCBZBcNM1GRCxjW36sQ/viewform'
                                      target='_blank'
                                    >
                                                <h2>{t('feedback_form')}</h2>
                                            </Card>
                                    </TopContent>
                                    <BottomContent>
                                      <h1>{t('bug_bounty')}</h1>
                                    <Button>
                                       1000 {t('tama_bug_glitch')}
                                    </Button>
                                    <Button>
                                       10,000 {t('tama_game_cheat')}
                                    </Button>
                                    </BottomContent>
                                </ModalContent>
                                <CloseModalButton
                                    onClick={() =>
                                        setIsFeedback(false)
                                    }
                                >
                                    <img
                                        src={Close}
                                        style={{ height: 20 }}
                                        alt='close'
                                    />
                                </CloseModalButton>
                            </ModalWrapper>
                        </animated.div>
                    </Background>
                </Modal>
            ) : null}
        </>
    );
};
